module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/knife-2-d2ff21def0376130c2f737e8ca8ec52e.svg";